import type { VoiceCommandResult } from './voiceCommandClient';

const normalizeVoiceDetailRoute = (route: string): string =>
  route.replace(/^\/invoices\/(\d+)$/, '/sales-invoices/$1');

const isPurchaseInvoiceAction = (result: VoiceCommandResult): boolean => {
  const action = (result.action || '').toLowerCase();
  const invoiceType = String(result.data?.invoice_type || '').toLowerCase();
  return (
    invoiceType === 'purchase'
    || action.includes('purchase')
    || action === 'create_bill'
  );
};

const resolveInvoiceDetailRoute = (result: VoiceCommandResult): string | null => {
  const invoiceId = result.data?.invoice_id;
  if (!invoiceId) return null;
  return isPurchaseInvoiceAction(result)
    ? `/purchase-invoices/${invoiceId}`
    : `/sales-invoices/${invoiceId}`;
};

/** Prefer entity detail routes over generic list-level navigateTo targets. */
export const resolveVoiceDetailRoute = (result: VoiceCommandResult): string | null => {
  const invoiceRoute = resolveInvoiceDetailRoute(result);
  if (invoiceRoute) return invoiceRoute;

  if (result.data?.quote_id) {
    return `/quotes/${result.data.quote_id}`;
  }

  if (result.data?.contact_id) {
    return `/contacts/${result.data.contact_id}`;
  }

  const expenseId = result.data?.expense_id ?? result.data?.expenseId;
  if (expenseId) {
    return `/expenses?view=${expenseId}`;
  }

  if (result.data?.journal_entry_id) {
    return `/journal-entries#journal-entry-${result.data.journal_entry_id}`;
  }

  if (result.data?.navigateTo) {
    return normalizeVoiceDetailRoute(String(result.data.navigateTo));
  }

  return null;
};
